export default __webpack_public_path__ + "static/media/Suzuki.b5e73caa.png";